import { render } from "./EmployeeTrainingFileForm.vue?vue&type=template&id=dd93aa9e"
import script from "./EmployeeTrainingFileForm.vue?vue&type=script&lang=js"
export * from "./EmployeeTrainingFileForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__